import styled from 'styled-components';

interface IProps {
    isMobile?: boolean;
}

export const NodeContainer = styled.div<IProps>`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    top: ${({ isMobile }) => isMobile && '50%'};
    transform: ${({ isMobile }) => isMobile && 'translateY(-50%)'};
    position: ${({ isMobile }) => isMobile && 'absolute'};

    & > div {
        position: relative;
    }
`;
